<template>
  <div class="main-table-wrapper">
    <el-table
      :data="data"
      style="width: 100%">
      <el-table-column
        :label="$tc('general.n0')"
        width="50px">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}.
        </template>
      </el-table-column>

      <el-table-column
        :label="$tc('form.image')"
        width="100px">
        <template slot-scope="scope">
          <main-image :src="$file('avatars', scope.row.avatar)" style="width: 75px; height: 75px" />
        </template>
      </el-table-column>

      <el-table-column
        :label="$tc('form.first_name')"
        width="200px">
        <template slot-scope="scope">
          {{ scope.row.firstName }}
        </template>
      </el-table-column>

      <el-table-column
        :label="$tc('form.last_name')">
        <template slot-scope="scope">
          {{ scope.row.lastName}}
        </template>
      </el-table-column>

      <template v-if="showClubName">
        <el-table-column
          :label="$tc('club.club_name')">
          <template slot-scope="scope">
            {{ scope.row.club ? scope.row.club.name : '' }}
          </template>
        </el-table-column>
      </template>

      <el-table-column
        :label="$tc('general.function')">
        <template slot-scope="scope">
          {{ scope.row.funct }}
        </template>
      </el-table-column>

      <el-table-column
        v-if="showIsActive && canEdit"
        :label="$tc('general.isActive')"
        width="100px"
        align="center">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.isActive"
            @change="updateActiveState(scope.row, $event)" />
        </template>
      </el-table-column>

      <el-table-column
        v-if="canEdit"
        :label="$tc('general.actions')"
        align="right">
        <template slot-scope="scope">
          <el-button v-if="!hideEdit" icon="el-icon-edit" circle @click="$emit('edit', scope.row)" />
          <el-button type="danger" icon="el-icon-delete" circle @click="beforeRemove(scope.row)" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import errorHandler from '@/common/errorHandler.js'

export default {
  props: {
    data: {
      type: Array,
      default: null
    },

    canEdit: {
      type: Boolean,
      default: false
    },

    showClubName: {
      type: Boolean,
      default: false
    },

    customLogic: {
      type: Boolean,
      default: null
    },

    hideEdit: {
      type: Boolean,
      default: false
    },

    showIsActive: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    async beforeRemove (official) {
      try {
        await this.$confirm(`${this.$tc('messages.ask_delete_official')}: ${official.firstName} ${official.lastName}`)
        if (this.customLogic) return this.$emit('custom-delete', official)

        this.onDelete(official)
      } catch {}
    },

    async onDelete (official) {
      const loading = this.$loading()
      try {
        await this.$store.dispatch('officials/delete', official.id)
        this.$message.success(this.$tc('messages.success_deleted_official'))
        this.$emit('delete', official)
      } catch (e) {
        console.error(e)
        errorHandler(e)
      } finally {
        loading.close()
      }
    },
    async updateActiveState (official, isActive) {
      try {
        const result = await this.$store.dispatch('officials/action', {
          id: official.id,
          action: 'setActive',
          payload: { isActive }
        })

        // Check if the action was successful
        if (result?.success !== false) {
          const updatedOfficial = result?.item || result?.response
          if (updatedOfficial) {
            this.$emit('update', updatedOfficial)
          } else {
            // If no updated official in response, try to get from store
            const storeOfficial = this.$store.getters['officials/get'](official.id)
            if (storeOfficial && storeOfficial.isActive === isActive) {
              this.$emit('update', storeOfficial)
            } else {
              // If store doesn't have the updated official, force update to revert switch
              this.$forceUpdate()
            }
          }
        } else {
          // Action was not successful, revert the switch
          this.$forceUpdate()
        }
      } catch (e) {
        console.error(e)
        errorHandler(e)
        // Revert the switch on error
        this.$forceUpdate()
      }
    }
  }
}
</script>
